module.exports = __webpack_public_path__ + "img/near-me.2.9e066f8.jpg";